<template>
  <div class="app app--auth">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.app--auth {
  background-color: $gray-100;
  display: flex;
  justify-content: center;
  min-height: 100vh;

  .app-content {
    margin: auto;
    max-width: 30rem;
    width: 100%;

    .block-header {
      height: auto;
      justify-content: center;

      .icon--brand {
        color: $brand-primary;
        display: block;
        fill: currentColor;
        height: 2.5rem;
        stroke: currentColor;
        stroke-width: 0;
        width: 8rem;
      }

      > img {
        max-height: 4.5rem;
        max-width: 100%;
      }
    }

    .sep {
      color: $gray-400;
      position: relative;
      text-align: center;

      &--or {
        &::after,
        &::before {
          background-color: currentColor;
          content: "";
          display: inline-block;
          height: 1px;
          vertical-align: middle;
          width: calc(50% - 1rem);
        }

        span {
          border: 1px solid currentColor;
          border-radius: 50%;
          display: inline-block;
          font-size: 0.75rem;
          height: 2rem;
          line-height: 2rem;
          vertical-align: middle;
          text-align: center;
          width: 2rem;
        }
      }
    }
  }
}
</style>
